import { render, staticRenderFns } from "./AlbumCoverZone.vue?vue&type=template&id=3def0df7&scoped=true&"
import script from "./AlbumCoverZone.vue?vue&type=script&lang=js&"
export * from "./AlbumCoverZone.vue?vue&type=script&lang=js&"
import style0 from "./AlbumCoverZone.vue?vue&type=style&index=0&id=3def0df7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3def0df7",
  null
  
)

export default component.exports